import { GenericObject } from '@synergy/models';

import { Activity } from './activity';
import { DocumentComment } from './document-comment';
import { SentMessage } from './sent-message';
import { TransitionActivity } from './transition-activity';

/**
 * What kind of thing happened. The stream can be narrowed to one of these; the
 * backend decides the kind, so the filter also narrows the count.
 */
export enum DocumentStreamKind {
    Status = 'status',
    Internal = 'internal',
    Message = 'message',
    System = 'system',
}

export class DocumentStreamEntry {
    public source!: 'activity' | 'transition' | 'comment' | 'message';
    public kind!: DocumentStreamKind;
    public occurredAt!: string;
    public activity: Activity | null = null;
    public transition: TransitionActivity | null = null;
    public comment: DocumentComment | null = null;
    public message: SentMessage | null = null;
    /**
     * Which document of a chain the entry belongs to. Empty on a single
     * document's stream, where the reader already knows whose sentence it is.
     */
    public documentType: string | null = null;
    public documentId: number | null = null;
    /**
     * How many entries of one save this one stands for — one, unless the save
     * wrote so many that the stream would be nothing but them (R-61).
     */
    public members = 1;

    public static fromPlainObject(object: GenericObject): DocumentStreamEntry {
        const entry = new DocumentStreamEntry();

        entry.source = object['source'];
        entry.kind = object['kind'];
        entry.occurredAt = object['occurredAt'];
        entry.members = object['members'] ?? 1;
        // Each side is the very DTO its own endpoint returns, so the existing
        // models read it without a second mapping.
        entry.activity = object['activity'] ? Activity.fromPlainObject(object['activity']) : null;
        entry.transition = object['transition'] ? TransitionActivity.fromPlainObject(object['transition']) : null;
        entry.comment = object['comment'] ? DocumentComment.fromPlainObject(object['comment']) : null;
        entry.message = object['message'] ? SentMessage.fromPlainObject(object['message']) : null;
        entry.documentType = object['documentType'] ?? null;
        entry.documentId = object['documentId'] ?? null;

        return entry;
    }
}

export interface DocumentStreamPage {
    entries: DocumentStreamEntry[];
    total: number;
    page: number;
    pages: number;
}
